export const PRACTICE = 'PRACTICE';
export const COMPETE = 'COMPETE';
export const HIT = 'HIT';
export const MISS = 'MISS';
export const CLEAR_LEVEL = 'MS CLEAR LEVEL';
export const RESET = 'RESET';
export const OVER = 'OVER';
export const TASKS_PER_LEVEL = 25;
export const LEVELS_COMPLETED_KEY = 'MS LEVELS COMPLETED';
export const SAVED_GAME_KEY = 'MS SAVED GAME';
export const STATS_KEY = 'MS STATS';
export const OPTIONS_KEY = 'MS OPTIONS';
export const YOUTUBE_MS = 'https://youtu.be/LympllOhJik';
